
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import FormField from "../../base_classes/FormField"

import SelectActivityDialog from "../dialogs/SelectActivityDialog.vue"
@Component({
    components: { SelectActivityDialog },
})
export default class ActivityField extends FormField {
    @Prop() errorRequired!: boolean

    selecting: boolean = false

    hide: boolean = false

    onClick() {
        if (this.editable) {
            this.selecting = true
        } else {
            console.warn("Activity is not editable")
        }
    }

    onClear() {
        const original = this.value && this.value.activityId
        this.value.activityName = null
        this.value.activityId = null
        this.$emit("input", this.value)
        if (original) this.$emit("change", this.value)
    }

    select(activity: any) {
        const original = this.value && this.value.activityId
        if (!activity) {
            this.onClear()
            return
        }
        this.selecting = false
        this.$emit("input", this.value)
        if (activity.id != this.value.activityId) {
            Vue.set(this.value, "activityId", activity.id)
            Vue.set(this.value, "activityName", activity.name)
            if (this.errorRequired) this.$emit("clearErrorRequired", "activity")
            if (original != this.value.activityId) this.$emit("change", this.value)
        }
    }
}
